import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';

export const ToolsStack = styled(Stack)`
  gap: 8px;
  width: 90%;
  padding: 8px;
  align-items: flex-start;
  overflow: hidden;
  margin-bottom: 24px;

  ${({ theme }) => theme.breakpoints.down('md')} {
    margin-top: 48px;
  }
`;
